import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { Component, ElementRef, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { Console, debug } from 'console';
import { Address } from '../../../../models/address';
import { ChargingPower } from '../../../../models/chargingPower';
import { Manufacturer } from '../../../../models/manufacturer';
import { Model } from '../../../../models/model';
import { ToastService } from '../../../../services/toast/toast.service';
import { v4 as uuidv4 } from 'uuid';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStation } from '../../../../models/charging-station';




@Component({
  selector: 'app-create-charging-station-assistent',
  templateUrl: './create-charging-station-assistent.component.html',
  styleUrls: ['./create-charging-station-assistent.component.css']
})
export class CreateChargingStationAssistentComponent extends AbstractCreateEntityComponent implements OnInit {

  public className = 'CreateChargingStationAssistentComponent';

  public inviteLink: string;
  public installDate = new Date().toISOString().slice(0, 16);

  @Input() customerId: number;
  @Input() public hideSubmit: boolean = false;

  guid: string = '';
  password: string = '';
  wssurl: string = 'wss://ocpp-dev.mycubos.com/api/ocpp';
  guidCopied: boolean = false;
  passwordCopied: boolean = false;
  waitForStationBtnDisabled: boolean = true;
  confirmCopyBtnDisabled: boolean = true;
  nextBtnDisabled: boolean = true;
  showStep1: boolean = true;
  showStep2: boolean = false;
  showStep3: boolean = false;
  public passwordLength: number = 12;
  public includeNumbers: boolean = true;
  public includeSymbols: boolean = false;


  constructor(
    public activeModal: NgbActiveModal,

    public toastService: ToastService,
    private chargingStationsService: ChargingStationsService,
    injector: Injector) {
    super(chargingStationsService, injector);
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.formService.validators = {
      name: [Validators.required],
      location: [],
      address: [Validators.required],
      manufacturerId: [Validators.required],
      modelId: [Validators.required],
      installationDate: [Validators.required],
      connectorSystemsId: [],
      key: [],
    }
    this.formService.form = new UntypedFormGroup({
      name: new UntypedFormControl('', this.formService.validators['name']),
      location: new UntypedFormControl('', this.formService.validators['location']),
      postalCode: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(5)]),
      city: new UntypedFormControl('', this.formService.validators['address']),
      street: new UntypedFormControl('', this.formService.validators['address']),
      houseNumber: new UntypedFormControl('', this.formService.validators['address']),
      key: new UntypedFormControl(this.password, this.formService.validators['key']),
    });
    this.generateCredentials();
  }

  onSubmit(formValue) {
    //console.log(formValue);
    var address = new Address();
    address.city = formValue.city;
    address.postalCode = formValue.postalCode;
    address.houseNumber = formValue.houseNumber;
    address.street = formValue.street;
    formValue.Address = address;
    formValue.location = formValue.street + " " + formValue.houseNumber + ", " + formValue.postalCode + " " + formValue.city;
    var entity = new ChargingStation(formValue);
    entity.id = this.guid;
    entity.key = this.password;
    //console.log(entity);
    this.chargingStationsService.createEntity(entity).subscribe(data => {
    }, error => { });
  }

  onCancelClick() {
    this.activeModal.close();
  }

  generateCredentials() {
    this.guid = crypto.randomUUID();
    this.generatePassword();

  }

  pwlength(event) {
    this.passwordLength = event.target.value;
    console.log(this.passwordLength);
  }

  hasNum(event) {
    this.includeNumbers = event.target.checked;
    console.log(this.includeNumbers);
  }

  hasSym(event) {
    this.includeSymbols = event.target.checked;
    console.log(this.includeSymbols);
  }


  generatePassword() {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

    let validChars = letters;
    if (this.includeNumbers) {
      validChars += numbers;
    }
    if (this.includeSymbols) {
      validChars += symbols;
    }

    let generatedPassword = '';
    for (let i = 0; i < this.passwordLength; i++) {
      const index = Math.floor(Math.random() * validChars.length);
      generatedPassword += validChars[index];
    }

    this.password = generatedPassword;
    this.formService.form.controls['key'].setValue(this.password);

  }


  copyToClipboard(text: string, type: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toastService.success(`${type} in die Zwischenablage kopiert!`,2000);
      if (type === 'Identität') this.guidCopied = true;
      if (type === 'Passwort') this.passwordCopied = true;
      this.checkCopies();
    });
  }

  checkCopies() {
    if (this.guidCopied && this.passwordCopied) {
      this.confirmCopyBtnDisabled = false;
    }
  }

  confirmCopy() {
    this.waitForStationBtnDisabled = false;
  }

  waitForStation() {
    const spinner = document.getElementById('waitForStationSpinner');
    if (spinner) spinner.classList.remove('d-none');
    setTimeout(() => {
      if (spinner) spinner.classList.add('d-none');
      this.showStep1 = false;
      this.showStep2 = true;
    }, 6000); // Simulate wait time
  }

  generateCoordinates() {
    const street = (document.getElementById('street') as HTMLInputElement).value;
    const houseNumber = (document.getElementById('houseNumber') as HTMLInputElement).value;
    const postalCode = (document.getElementById('postalCode') as HTMLInputElement).value;
    const city = (document.getElementById('city') as HTMLInputElement).value;

    if (street && houseNumber && postalCode && city) {
      const query = `${street} ${houseNumber}, ${postalCode} ${city}`;
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`;

      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data && data.length > 0) {
            const lat = data[0].lat;
            const lon = data[0].lon;
            (document.getElementById('coordinates_lat') as HTMLInputElement).value = `${lat}`;
            (document.getElementById('coordinates_lon') as HTMLInputElement).value = `${lon}`;
            this.nextBtnDisabled = false; // Enable "Weiter" button after getting coordinates
          } else {
            this.toastService.warn("Keine Koordinaten für die angegebene Adresse gefunden.");
          }
        })
        .catch(error => {
          this.toastService.error("Fehler beim Abrufen der Geo-Koordinaten.");
          console.error("Fehler bei der Geocodierung:", error);
        });
    } else {
      this.toastService.warn("Bitte füllen Sie alle Adressfelder aus.");
    }
  }


  moveToNextStep() {
    if (this.showStep1) {
      this.showStep1 = false;
      this.showStep2 = true;
    } else if (this.showStep2) {
      this.showStep2 = false;
      this.showStep3 = true;
    } else if (this.showStep3) {
      this.closeModal();
    }
  }

  closeModal() {
    const modal = document.getElementById('setupModal');
    if (modal) {
      modal.style.display = 'none';
    }
  }

  backToPreviousStep() {
    if (this.showStep3) {
      this.showStep3 = false;
      this.showStep2 = true;
    } else if (this.showStep2) {
      this.showStep2 = false;
      this.showStep1 = true;
    }
  }

}
